function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.3 2H19.7C20.5752 2 21.4146 2.35119 22.0335 2.97631C22.6523 3.60143 23 4.44928 23 5.33333V8.66667C23 8.96135 22.8841 9.24397 22.6778 9.45234C22.4715 9.66071 22.1917 9.77778 21.9 9.77778H20.8V18.6667C20.8 19.5507 20.4523 20.3986 19.8335 21.0237C19.2146 21.6488 18.3752 22 17.5 22H6.5C5.62479 22 4.78542 21.6488 4.16655 21.0237C3.54768 20.3986 3.2 19.5507 3.2 18.6667V9.77778H2.1C1.80826 9.77778 1.52847 9.66071 1.32218 9.45234C1.11589 9.24397 1 8.96135 1 8.66667V5.33333C1 4.44928 1.34768 3.60143 1.96655 2.97631C2.58542 2.35119 3.42479 2 4.3 2ZM3.2 7.55556H20.8V5.33333C20.8 5.03865 20.6841 4.75603 20.4778 4.54766C20.2715 4.33929 19.9917 4.22222 19.7 4.22222H4.3C4.00826 4.22222 3.72847 4.33929 3.52218 4.54766C3.31589 4.75603 3.2 5.03865 3.2 5.33333V7.55556ZM8.5 12C8.22386 12 8 12.2239 8 12.5V13.5C8 13.7761 8.22386 14 8.5 14H15.5C15.7761 14 16 13.7761 16 13.5V12.5C16 12.2239 15.7761 12 15.5 12H8.5Z",
  fill: "currentColor"
});

var SvgProjector = function SvgProjector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProjector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/projector.06e913ea.svg";
export { ForwardRef as ReactComponent };